import { render, staticRenderFns } from "./eg.vue?vue&type=template&id=3d387efc&scoped=true"
import script from "./eg.vue?vue&type=script&lang=js"
export * from "./eg.vue?vue&type=script&lang=js"
import style0 from "./eg.vue?vue&type=style&index=0&id=3d387efc&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d387efc",
  null
  
)

export default component.exports